
import { defineComponent, reactive, onBeforeMount } from 'vue'
import { AxiosResponse } from 'axios'
import ScheduleRadio from '@/components/inputs/ScheduleRadio.vue'
import { ScheduleAnserGet, ScheduleAnswerDatePost, ScheduleCandidateDate } from '@/api'
import { ListRequest as AnswerListRequest } from '@/requests/scheduleAnswer'
import { ListRequest as CandidateListRequest } from '@/requests/schedule'

/**
 * 表示用候補日
 */
interface Schedule extends ScheduleAnswerDatePost {
  schedule_candidate_date: number
  date: string
  selectable_time_type: number
}

/**
 * 日程選択グループ(回答)
 */
export default defineComponent({
  name: 'ApplicantHistoryScheduleRadioGroup',
  components: {
    ScheduleRadio,
  },
  props: {
    messageId: {
      type: Number,
      required: true,
    },
    isJrSendType: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props) {
    const scheduleRadios = reactive<Schedule[]>([])

    onBeforeMount(async () => {
      scheduleRadios.splice(0)

      //日程候補取得
      const candidateRequest = new CandidateListRequest(props.messageId)
      if (!(await candidateRequest.exec())) {
        return
      }
      const { data: candidates } = candidateRequest.getResponse() as AxiosResponse<ScheduleCandidateDate[]>

      // 日程回答取得
      const answerRequest = new AnswerListRequest(props.messageId)
      if (!(await answerRequest.exec())) {
        return
      }
      const { data: schedules } = answerRequest.getResponse() as AxiosResponse<ScheduleAnserGet[]>
      if (schedules.length !== 1) {
        throw new Error(`回答情報が取得できませんでした。 message_id: ${props.messageId}`)
      }
      const answers = schedules[0].schedule_answer_date

      // Radioの選択肢を作成する
      scheduleRadios.push(
        ...candidates.map((candidate) => {
          // JRのメッセージなら候補情報の時間帯を設定
          // 申請者からのメッセージなら回答情報の時間帯を設定
          let time_type
          if (props.isJrSendType) {
            time_type = candidate.selectable_time_type
          } else {
            const answer = answers.find(
              (answer) => answer.schedule_candidate_date === candidate.schedule_candidate_date_id
            )
            // 申請者からのメッセージの場合、回答情報があるはずなので、
            // 取得できなかった場合例外送出
            if (answer == null) {
              throw new Error(`回答情報が取得できませんでした。 message_id: ${props.messageId}`)
            }
            time_type = answer.time_type
          }
          return {
            schedule_candidate_date: candidate.schedule_candidate_date_id as number,
            date: candidate.date,
            time_type,
            selectable_time_type: candidate.selectable_time_type,
          }
        })
      )
    })

    return {
      scheduleRadios,
    }
  },
})
